"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var rql_1 = require("../../schemas/rql");
var money_1 = require("@reverbdotcom/commons/dist/money");
function activeNegotiation(me) {
    return lodash_1.head(lodash_1.get(me, 'activeNegotiation.negotiations', []));
}
exports.activeNegotiation = activeNegotiation;
function lastOffer(negotiation) {
    return lodash_1.get(negotiation, 'lastOffer');
}
exports.lastOffer = lastOffer;
function listingShippingPrice(listing) {
    return lodash_1.head(lodash_1.get(listing, 'shipping.shippingPrices', []));
}
exports.listingShippingPrice = listingShippingPrice;
function offerShippingPriceAmount(currentOfferShippingPrice, me) {
    if (lodash_1.isNil(currentOfferShippingPrice)) {
        var prices = lastOfferPrices(me);
        var shippingAmount = lodash_1.get(prices, 'shippingPrice.amount', 0);
        return money_1.formatAmount({
            amount: shippingAmount,
            symbol: '',
        });
    }
    return currentOfferShippingPrice;
}
exports.offerShippingPriceAmount = offerShippingPriceAmount;
function offerOriginalShippingPriceAmount(lastOffer) {
    return lodash_1.get(lastOffer, 'prices.shippingPrice.original');
}
exports.offerOriginalShippingPriceAmount = offerOriginalShippingPriceAmount;
function offerQuantity(lastOffer, currentOfferQuantity) {
    if (!currentOfferQuantity) {
        return lodash_1.get(lodash_1.head(lodash_1.get(lastOffer, 'offerItems', [])), 'quantity', 1);
    }
    return currentOfferQuantity;
}
exports.offerQuantity = offerQuantity;
function lastOfferPrices(me) {
    return lastOfferPricesFor(currentParty(me), activeNegotiation(me));
}
exports.lastOfferPrices = lastOfferPrices;
function lastOfferPricesFor(party, negotiation) {
    var key = (party === rql_1.core_apimessages_NegotiationParty.SELLER) ?
        'original' : 'display';
    var offer = lastOffer(negotiation);
    return {
        price: lodash_1.get(offer, "prices.price." + key),
        shippingPrice: lodash_1.get(offer, "prices.shippingPrice." + key),
        totalPrice: lodash_1.get(offer, "prices.totalPrice." + key),
    };
}
exports.lastOfferPricesFor = lastOfferPricesFor;
function currentParty(me) {
    var currentPartyUUID = lodash_1.get(me, 'uuid');
    var sellerUUID = lodash_1.get(activeNegotiation(me), 'sellerUuid');
    if (currentPartyUUID === sellerUUID) {
        return rql_1.core_apimessages_NegotiationParty.SELLER;
    }
    return rql_1.core_apimessages_NegotiationParty.BUYER;
}
exports.currentParty = currentParty;
function originalCurrency(data) {
    var negotiation = activeNegotiation(lodash_1.get(data, 'me'));
    if (negotiation) {
        var offer = lastOffer(negotiation);
        return lodash_1.get(offer, 'prices.price.original.currency');
    }
    return lodash_1.get(data, 'listing.shop.currency');
}
exports.originalCurrency = originalCurrency;
function userCurrency(data, user) {
    var party = currentParty(lodash_1.get(data, 'me'));
    if (party === rql_1.core_apimessages_NegotiationParty.SELLER) {
        return originalCurrency(data);
    }
    return user.currency;
}
exports.userCurrency = userCurrency;
//# sourceMappingURL=negotiation_getters.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/negotiation_getters.js
// module id = nIhU
// module chunks = 20 21